import { useMediaQuery } from "@material-ui/core";
import Collapse from "@material-ui/core/Collapse";
import Drawer from "@material-ui/core/Drawer";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import CloseIcon from "@material-ui/icons/Close";
import { navigate } from "@reach/router";
import _ from "lodash";
import React, { useState } from "react";
import { scroller } from "react-scroll";
import styled from "styled-components";
import COLORS from "../../../assets/Colors";
import { Images } from "../../../assets/images";
import labels from "../../../helpers/labels.json";
import useSettings from "../../../hooks/useSettings";
import { CompanyLogo } from "../../../styles/component/style";
import { sidebar_options } from "./constants";
import { LogoContainer, SmallScreen } from "./Styles";
import theme from "../../../assets/theme";
import Tooltip from "react-tooltip-lite";

/* eslint-disable jsx-a11y/anchor-is-valid */

const drawerWidth = 273;

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
    [theme.breakpoints.down("xs")]: {
      position: "absolute",
    },
  },
  drawerContainer: {
    overflow: "auto",
    height: "100%",
  },
  inactiveListItem: {
    padding: "0px",
    borderBottom: "1px solid #e1e3ee",
    paddingLeft: 47,
    height: 57,
  },
  activeListItem: {
    padding: "0px",
    paddingLeft: 47,
    height: 57,
    backgroundColor: "#293461 !important",
  },

  nested: {
    margin: "0 0 15px 0",
    marginLeft: "60px",
    width: "200px",
    height: "38px",
    borderRadius: "5px",
    transition: "300ms",
    boxSizing: "borderbox",
    "& span": {
      transition: "250ms",
      fontSize: "14px",
    },
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.05)",
      borderLeft: "3px solid #fff",
      "& span": {
        color: "#fff",
      },
    },
  },
  wrapperInner: {
    backgroundColor: "#293461",
  },
  inactiveNested: {
    backgroundColor: "transparent",
  },
  activeNested: {
    backgroundColor: "rgba(255, 255, 255, 0.05)",
    borderLeft: "3px solid #fff",
  },
}));

export default function Sidebar({
  selectedItem,
  selectedSubItem,
  stats,
  showDrawer,
  setShowDrawer,
  LandingPage,
  userObject,
}) {
  const classes = useStyles();
  const [expand, setExpand] = useState(true);
  const themes = useTheme();
  const isBigScreen = useMediaQuery(themes.breakpoints.up(1240));
  const { setting, settingsLoading } = useSettings();

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setShowDrawer(false);
  };

  const performanceNavigation = (data) => {
    if (data.hasOwnProperty("listItems") && data.title === selectedItem) {
      if (data.title === labels.my_cases && checkExpansion()) {
        setExpand(!expand);
      } else {
        navigate(data.path);
        setShowDrawer(false);
      }
    } else {
      navigate(data.path);
      setShowDrawer(false);
    }
  };

  const checkExpansion = () => {
    if (stats?.negotiationCount && stats?.mediationCount) {
      return true;
    }
    if (stats?.mediationCount && stats?.arbitrationCount) {
      return true;
    }
    if (stats?.arbitrationCount && stats?.negotiationCount) {
      return true;
    }
    return true;
  };

  return (
    <Drawer
      open={showDrawer}
      onClose={toggleDrawer(false)}
      className={classes.drawer}
      variant={isBigScreen ? "permanent" : "temporary"}
      classes={{
        paper: classes.drawerPaper,
      }}
    >
      <Toolbar />
      <div className={classes.drawerContainer}>
        <SmallScreen
          style={{
            position: "absolute",
            top: 0,
            width: "100%",
            height: "74px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <LogoContainer>
            {settingsLoading ? null : (
              <CompanyLogo
                onClick={() => {
                  LandingPage
                    ? scroller.scrollTo("hero", {
                        duration: 500,
                        offset: -70,
                        smooth: true,
                      })
                    : _.isEmpty(userObject) || !userObject?.emailVerified
                    ? navigate("/")
                    : navigate("/dashboard");
                  setShowDrawer(false);
                }}
                src={setting?.logoUrl || Images.companyLogo}
              />
            )}
          </LogoContainer>
          <IconButton
            edge="end"
            color="inherit"
            aria-label="menu"
            onClick={() => {
              setShowDrawer(false);
            }}
            style={{ marginRight: 10 }}
          >
            <CloseIcon style={{ color: `${COLORS.COLOR_DARK}` }} />
          </IconButton>
        </SmallScreen>
        <List>
          {sidebar_options.map((data, index) => (
            <React.Fragment key={index}>
              <ListItem
                className={
                  data.title === selectedItem
                    ? classes.activeListItem
                    : classes.inactiveListItem
                }
                button
                onClick={() => {
                  performanceNavigation(data);
                }}
                key={data.title}
              >
                <ListItemIcon>
                  <Icon
                    src={
                      data.title === selectedItem ? data.icon : data.inactive
                    }
                  />
                </ListItemIcon>
                <ListItemText selected={data.title === selectedItem}>
                  <div className="row flex center-center">
                    <div className="flex flex-1">{_.startCase(data.title)}</div>
                    <div className="mr30 flex">
                      {data.hasOwnProperty("listItems") && checkExpansion() && (
                        <>
                          {expand && data.title === selectedItem ? (
                            <ExpandLess />
                          ) : (
                            <ExpandMore />
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </ListItemText>
              </ListItem>
              {data.hasOwnProperty("listItems") && checkExpansion() && (
                <Collapse
                  in={data.title === selectedItem && expand}
                  timeout="auto"
                  unmountOnExit
                  className={classes.wrapperInner}
                >
                  <List
                    style={{
                      borderBottom: `solid 0.3px rgba(255, 255, 255, 0.12)`,
                    }}
                    component="div"
                    disablePadding
                  >
                    {data.listItems.map((li, index) => (
                      <Tooltip
                        content={[
                          <CommentContainer
                            style={{ backgroundColor: COLORS.BORDER_GREY }}
                          >
                            {
                              <b>
                                &nbsp;
                                <a
                                  style={{
                                    fontFamily: theme.fonts.primaryFontSemiBold,
                                    color: COLORS.BTN_GREEN,
                                    textDecoration: "underline",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    navigate(
                                      `/dashboard/help#about-arbitration`
                                    )
                                  }
                                >
                                  Arbitration
                                </a>{" "}
                                is similar to a procedure driven resolution
                                method akin to a private court. Click to learn
                                more.
                              </b>
                            }
                          </CommentContainer>,
                        ]}
                        arrow={false}
                        tagName="span"
                        direction="right"
                        className="target"
                        tipContentClassName=""
                        tipContentHover
                      >
                        <React.Fragment key={index}>
                          <ListItem
                            key={index}
                            button
                            className={`${classes.nested} ${
                              li.title === selectedSubItem
                                ? classes.activeNested
                                : classes.inactiveNested
                            }`}
                            onClick={() => {
                              navigate(li.path);
                              setShowDrawer(false);
                            }}
                          >
                            <ListItemIcon>
                              <Icon
                                src={
                                  li.title === selectedSubItem
                                    ? li.icon
                                    : li.inactive
                                }
                              />
                            </ListItemIcon>
                            <ListItemText
                              selected={li.title === selectedSubItem}
                            >
                              {_.startCase(li.title)}
                            </ListItemText>
                          </ListItem>
                        </React.Fragment>
                      </Tooltip>
                    ))}
                  </List>
                </Collapse>
              )}
            </React.Fragment>
          ))}
        </List>
      </div>
    </Drawer>
  );
}

const ListItemText = styled.span`
  font-family: openSans-bold, sans-serif;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  width: 100%;
  color: ${({ selected }) => (selected ? "#ffffff" : "#acb1c2")};
`;

const Icon = styled.img`
  object-fit: contain;
  width: 16px;
  height: auto;
  color: #acb1c2;
`;

const ListItemIcon = styled.div`
  margin-right: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CommentContainer = styled.div`
  padding: 12px;
  border-radius: 7px;
  margin-bottom: 12px;
  // max-width: auto;
`;
